
import { create } from 'zustand'
import { deviceType, userType } from './types'
//import useCheckToken from '../hooks/useCheckToken';
//import { useEffect } from 'react';



/*
 *  interface appState 
 *  Es una interfase o declaración de variables que son utilizadas como variables de estado de nuestra aplicación.
 *  Todas estas variables y funciones han sido definidas por nosotros.
 * 
*/
interface appState {
    isLoading: boolean,
    updateIsLoading: (estado: boolean) => void,
    //Para mostrar el gráfico de loading cuando se hacen consultas al servidor
    showLoading: boolean,
    startLoading: () => void,
    endLoading: () => void,
    //Para mostrar la ventana de Login a la página y actualizar los datos del usuario
    showLogin: boolean,
    openLogin: () => void,
    closeLogin: () => void,
    //Datos del usuario logueado
    currentUser: userType,
    updateUser: (newUser: userType) => void,
    clearUser: () => void,
    //Datos del dispositivo a ser gestionado
    device: deviceType,
    setDevice: (dev: deviceType) => void,
    clearDevice: () => void,
    //Datos del usuario gestionado, no el logueado
    deviceUser: userType,
    setDeviceUser:(user: userType) => void,
}

export const useAppStore = create<appState>((set) => {
    const noUser: userType = { id: 0, name: '', email: '', photoURL: '', tipoUsuario: '', token: '' };
    var currentUserSaved: userType = noUser;
    const noDev: deviceType = { id: 0, devId: 0}
    
    try {
        //console.log("Recuperando currentUserSaved");
        currentUserSaved = JSON.parse(localStorage.getItem('currentUser') || 'null') || noUser;   //currentUserSaved será noUser si JSON.parse da nulo
    } catch (error) {
        //console.log("Error al parsear localStorage user:", error);
    }

    //console.log(currentUserSaved);
    return {
        isLoading: false,
        updateIsLoading: (estado: boolean) => set({ isLoading: estado }),
        //Para mostrar el gráfico de loading cuando se hacen consultas al servidor
        showLoading: false,
        startLoading: () => set({ showLoading: true }),
        endLoading: () => set({ showLoading: false }),
        //Para mostrar la ventana de Login a la página y actualizar los datos del usuario
        showLogin: false,
        openLogin: () => set({ showLogin: true }),
        closeLogin: () => set({ showLogin: false }),
        currentUser: currentUserSaved,
        updateUser: (newUser: userType) => {
            set({ currentUser: newUser });
            localStorage.setItem('currentUser', JSON.stringify(newUser));
            //console.log(newUser);
        },
        clearUser: () => {
            set({ currentUser: noUser })
            localStorage.setItem('currentUser', JSON.stringify(null));
            //console.log("clearUser");
        },
        //Datos del dispositivo a ser gestionado
        device: noDev,
        setDevice: (dev: deviceType) => set({device: dev}),
        clearDevice: () => set({device: noDev}),
        //Datos del usuario gestionado, no el logueado
        deviceUser: noUser,
        setDeviceUser: (user: userType) => set({deviceUser: user})
    }
})


